import React, { useRef, useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';

import Table from 'components/common/Table';
import SequenceEditModal from 'components/admin/sequence/SequenceEditModal';

import { adminSequenceApi } from 'api';

import { ADMIN_SEQUENCE_LIST_COLUMNS } from 'constants/admin/sequence';

const Sequence = () => {
  const tableRef = useRef();

  const [modalConfig, setModalConfig] = useState({
    show: false,
    sequence: null,
  });

  const handleShowEditModal = sequence => {
    setModalConfig({
      show: true,
      sequence,
    });
  };

  const handleCloseEditModal = () => {
    setModalConfig({
      show: false,
      sequence: null,
    });
  };
  const handleEditSuccess = () => {
    if (tableRef.current) {
      tableRef.current.refetch();
    }
  };

  const extendedColumns = useMemo(() => {
    const actionColumn = {
      id: 'actions',
      header: '',
      enableSorting: false,
      meta: {
        headerProps: { className: 'text-center' },
        cellProps: { className: 'text-center' },
      },
      cell: ({ row: { original } }) => (
        <Button
          variant="primary"
          size="sm"
          onClick={() => handleShowEditModal(original)}
        >
          Update
        </Button>
      ),
    };

    return [...ADMIN_SEQUENCE_LIST_COLUMNS, actionColumn];
  }, []);

  return (
    <>
      <Table
        ref={tableRef}
        title="Sequence"
        apiService={adminSequenceApi}
        columns={extendedColumns}
        fetchConfig={{
          transformResponse: response => ({
            data: response || [],
            totalItems: response?.length || 0,
          }),
        }}
        enablePagination={false}
      />

      <SequenceEditModal
        show={modalConfig.show}
        onHide={handleCloseEditModal}
        onSuccess={handleEditSuccess}
        sequence={modalConfig.sequence}
      />
    </>
  );
};

export default Sequence;
